import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/home/Index";
import NotFound from "./pages/not-found/Index";
import EgyptPage from "./pages/destinations/Egipt";
import TurciaPage from "./pages/destinations/Turcia";
import GreciaPage from "./pages/destinations/Grecia";
import ZanzibarPage from "./pages/destinations/Zanzibar";
import SpaniaPage from "./pages/destinations/Spania";
import MuntenegruPage from "./pages/destinations/Muntenegru";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          {/* ── Pagini destinații SEO ── */}
          <Route path="/egipt" element={<EgyptPage />} />
          <Route path="/turcia" element={<TurciaPage />} />
          <Route path="/grecia" element={<GreciaPage />} />
          <Route path="/zanzibar" element={<ZanzibarPage />} />
          <Route path="/spania" element={<SpaniaPage />} />
          <Route path="/muntenegru" element={<MuntenegruPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
